import { NavLink } from "react-router-dom";
import {
  getPracticalExamplePage,
  practicalExampleLinks,
} from "../content/practicalExampleCluster";
import "../style/manualTestingCluster.css";

function sectionId(title) {
  return title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}

function ExampleList({ title, items, className = "" }) {
  return (
    <section className={`manual-cluster-section ${className}`} id={sectionId(title)}>
      <h2>{title}</h2>
      <ul>
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </section>
  );
}

export default function PracticalExampleClusterPage({ slug }) {
  const page = getPracticalExamplePage(slug);

  if (!page) {
    return null;
  }

  return (
    <article className="manual-cluster-page practical-example-page">
      <div className="manual-cluster-intro">
        <span>Practical Example</span>
        <p>{page.scenario}</p>
      </div>

      <ExampleList title="Preconditions" items={page.preconditions} />
      <ExampleList title="Test data" items={page.testData} />

      <section className="manual-cluster-section" id="step-by-step-example">
        <h2>Step-by-step example</h2>
        <ol className="practical-step-list">
          {page.steps.map((step, index) => (
            <li key={step}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              {step}
            </li>
          ))}
        </ol>
      </section>

      <ExampleList title="Expected results" items={page.expectedResults} />
      <ExampleList title="Common bugs to watch" items={page.commonBugs} />

      <section className="manual-cluster-section" id="automation-note">
        <h2>Automation note</h2>
        <p>{page.automationHint}</p>
      </section>

      <section className="manual-cluster-faq manual-cluster-section" id="faq">
        <h2>FAQ</h2>
        {page.faqs.map((faq) => (
          <details key={faq.question}>
            <summary>{faq.question}</summary>
            <p>{faq.answer}</p>
          </details>
        ))}
      </section>

      <section className="manual-cluster-links" aria-label="Related QA Coder learning links">
        <h2>Next action</h2>
        <p>
          Turn this example into career-ready skill by practicing automation,
          revising interview answers, and connecting it with the right learning path.
        </p>
        <div>
          {practicalExampleLinks.map((link) => (
            <NavLink to={link.to} key={link.to}>
              {link.label}
            </NavLink>
          ))}
        </div>
      </section>
    </article>
  );
}
